import { render, staticRenderFns } from "./my2.vue?vue&type=template&id=252b479b&scoped=true&"
import script from "./my2.vue?vue&type=script&lang=js&"
export * from "./my2.vue?vue&type=script&lang=js&"
import style0 from "./my2.vue?vue&type=style&index=0&id=252b479b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252b479b",
  null
  
)

export default component.exports